import { useEffect, useState } from "react";
import { Box, Button, Text, FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import MyDiv from "./signature.style";
import { CustomToast } from "../../../../../components";
import { useFetch } from "../../../../../hooks/useFetch";
import RichTextEditor from "../../../../../components/RichEditorText/richEditorText";
import { ISignature, SignatureFields, SignatureSchema } from "./model";
import { props } from "../EmployerDetails/employerDetails";

const emptySignature: ISignature = {
    id: null,
    shortSignature: "",
    fullSignature: "",
};

const Signature = ({ employeeId }: props) => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);

    const [signature, setSignature] = useState<ISignature>(emptySignature);
    const [errors, setErrors] = useState<Partial<Record<keyof ISignature, string>>>({});
    const [loading, setLoading] = useState(false);
    const isUpdate = !!signature.id;

    const loadSignature = async () => {
        const response = await fetchApi("Signature", "GET", null, `employeeId=${employeeId}`, "");
        setSignature(response && response.id ? { ...emptySignature, ...response } : emptySignature);
    };

    useEffect(() => {
        loadSignature();
    }, [employeeId]);
    
    const handleChange = (key: "shortSignature" | "fullSignature", value: string) => {
        setSignature((prev) => ({ ...prev, [key]: value }));
        setErrors((prev) => ({ ...prev, [key]: undefined }));
    };

    const handleSave = async () => {
        try {
            await SignatureSchema.validate(signature, { abortEarly: false });
        } catch (err: any) {
            const fieldErrors: Record<string, string> = {};
            err.inner?.forEach((e: any) => {
                if (e.path) fieldErrors[e.path] = e.message;
            });
            setErrors(fieldErrors);
            return;
        }

        setLoading(true);
        const payload = isUpdate 
            ? { id: signature.id, employeeId: Number(employeeId), shortSignature: signature.shortSignature, fullSignature: signature.fullSignature } 
            : { employeeId: Number(employeeId), shortSignature: signature.shortSignature, fullSignature: signature.fullSignature };
        const response = await fetchApi("Signature", isUpdate ? "PUT" : "POST", payload, null, isUpdate ? "Signature updated successfully" : "Signature saved successfully");
        setLoading(false);
        if (response) loadSignature();
    };

    return (
        <MyDiv>
            <Text as="h2" className="font-poppins page-title" fontSize="lg" fontWeight="600" mb={4}>
                Employee Signature
            </Text>

            <Box className="card_box" bg="#FFFFFF" borderRadius={8} p={6}>
                {SignatureFields.map((field) => (
                    <FormControl key={field.key} mb={6} isInvalid={!!errors[field.key]}>
                        <FormLabel className="label-title" mb={0}>
                            {field.label}
                        </FormLabel>
                        <Text className="label-desc" fontSize="xs" color="gray.500" mb={2}> {field.desc} </Text>
                        <Box className="editor-wrapper">
                            <RichTextEditor value={signature[field.key]} height={250} onChange={(value: string) => handleChange(field.key, value)} />
                        </Box>
                        <FormErrorMessage>{errors[field.key]}</FormErrorMessage>
                    </FormControl>
                ))}

                <Box className="save-btn-container" display="flex" justifyContent="flex-end">
                    <Button isLoading={loading} onClick={handleSave} className="btn_theme">
                        {isUpdate ? "Update Signature" : "Save Signature"}
                    </Button>
                </Box>
            </Box>
        </MyDiv>
    );
};

export default Signature;